import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecialOfferPopupComponent } from './special-offer-popup/special-offer-popup.component';
import {SpecialOfferService} from './special-offer.service';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {ShareModule} from '../share/share.module';



@NgModule({
  declarations: [SpecialOfferPopupComponent],
  imports: [
    CommonModule,
    NgbModalModule,
    ShareModule
  ],
  providers: [SpecialOfferService],
  exports: [
    SpecialOfferPopupComponent
  ]
})
export class SpecialOfferModule { }
